import { useEffect } from "react";

export default function useDisableBodyScroll(disable) {
  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;

    if (disable) {
      // Prevent scrolling on both html and body
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';

      // iOS fix: prevent touch scroll
      const preventScroll = (e) => e.preventDefault();
      document.addEventListener('touchmove', preventScroll, { passive: false });

      return () => {
        body.style.overflow = '';
        html.style.overflow = '';
        document.removeEventListener('touchmove', preventScroll);
      };
    } else {
      body.style.overflow = '';
      html.style.overflow = '';
    }
  }, [disable]);
}
